import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../features/auth/useAuth";
import { useApi } from "../../services/useApi";

const SideNav = () => {
  const navigate = useNavigate();
  const { clearAuth } = useAuth();
  const api = useApi();

  const handleSignOut = () => {
    api.setToken(null);
    clearAuth();
    navigate("/login");
  };

  return (
    <aside className="sidenav">
      <div className="sidenav-brand">
        <img
          src="/icons/Logo_PNG.png"
          alt="CatchClicker"
          className="sidenav-logo"
        />
        <div className="sidenav-title">Dashboard</div>
      </div>

      <nav className="sidenav-links">
        <div className="sidenav-group">
          <div className="sidenav-group-title">History</div>
          <NavLink to="/individual">Individual</NavLink>
          <NavLink to="/teams">Teams</NavLink>
        </div>

        <div className="sidenav-group sidenav-group-secondary">
          <a
            href="https://catchclicker.com/pages/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            Account and agreement
          </a>
          <a
            href="https://catchclicker.com/pages/contact"
            target="_blank"
            rel="noreferrer"
          >
            FAQ & Support
          </a>
          <a href="https://catchclicker.com/" target="_blank" rel="noreferrer">
            Shop Now
          </a>
          <button
            type="button"
            onClick={handleSignOut}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              textAlign: "left",
              cursor: "pointer",
            }}
          >
            Sign out
          </button>
        </div>
      </nav>
    </aside>
  );
};

export default SideNav;
